(function() {
  'use strict';
  
  const POPUP_CONFIG = {
    showDelay: 3000, 
    expireDate: new Date('2025-05-27'),
  };

  function shouldShowPopup() {
    const now = new Date();
    if (now >= POPUP_CONFIG.expireDate) return false;
    
    const currentPath = window.location.pathname;
    const isHomepage = currentPath === '/' || currentPath === '';
    
    return isHomepage;
  }

  function createPopupHTML() {
    const popupHTML = `
      <div id="memorialPopupOverlay" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.6); z-index: 99999; backdrop-filter: blur(2px);">
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; border-radius: 15px; box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3); max-width: 600px; width: 90%; max-height: 90vh; overflow: hidden; animation: popupSlideIn 0.4s ease-out;">
          
          <div style="background-image: url('https://cdn.shopify.com/s/files/1/0580/6918/8702/files/Architecturalglass_photo_for_ad.png?v=1748021413'); background-size: cover; background-position: center; background-repeat: no-repeat; height: 200px; position: relative; display: flex; align-items: center; justify-content: center;">
            <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.4);"></div>
            
            <button onclick="closeMemorialPopup()" style="position: absolute; top: 15px; right: 15px; background: rgba(255, 255, 255, 0.2); border: none; color: white; font-size: 24px; width: 35px; height: 35px; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 2; transition: all 0.3s ease;">&times;</button>
            
            <div style="text-align: center; position: relative; z-index: 1;">
              <h2 style="color: white; font-size: 32px; font-weight: bold; margin: 0; text-shadow: 2px 2px 4px rgba(0,0,0,0.7);">MEMORIAL DAY SALE!</h2>
            </div>
          </div>
          
          <div style="padding: 35px 30px; text-align: center; background: white;">
            <div style="background: linear-gradient(135deg, #4a6fa5, #3d5a8c); color: white; font-size: 36px; font-weight: 900; padding: 25px; border-radius: 50%; width: 140px; height: 140px; display: flex; flex-direction: column; align-items: center; justify-content: center; margin: 0 auto 25px; box-shadow: 0 8px 25px rgba(74, 111, 165, 0.4); animation: pulse 2s infinite; line-height: 1.1;">
              <span style="font-size: 42px; margin-bottom: -5px;">10%</span>
              <span style="font-size: 28px; letter-spacing: 1px;">OFF</span>
            </div>
            
            <p style="font-size: 19px; color: #333; line-height: 1.6; margin-bottom: 25px; font-weight: 500;">
              <strong>Memorial Day sale! 10% off sitewide – no coupon code needed. Sale is 5/22- 5/26</strong><br>
              <span style="color: #666; font-size: 16px;">Discount automatically applied at checkout</span>
            </p>
            
            <div style="background: linear-gradient(135deg, #f8f9fa, #e9ecef); border-left: 4px solid #7aa3d1; padding: 18px; margin: 25px 0; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.05);">
              <strong style="color: #4a6fa5; font-size: 17px; display: block; margin-bottom: 5px;">Sale Period: May 22nd - May 26th</strong>
              <small style="color: #666;">Don't miss out on these patriotic savings!</small>
            </div>
            
            <button onclick="closeMemorialPopup()" style="background: linear-gradient(135deg, #7aa3d1, #6290c2); color: white; border: none; padding: 16px 35px; font-size: 18px; font-weight: bold; border-radius: 25px; cursor: pointer; box-shadow: 0 4px 15px rgba(122, 163, 209, 0.3); margin: 10px; transition: all 0.3s ease; text-transform: uppercase; letter-spacing: 0.5px;">
              SHOP NOW & SAVE!
            </button>
          </div>
        </div>
      </div>

      <style>
      @keyframes popupSlideIn {
        from { opacity: 0; transform: translate(-50%, -60%); }
        to { opacity: 1; transform: translate(-50%, -50%); }
      }

      @keyframes pulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.05); }
        100% { transform: scale(1); }
      }

      #memorialPopupOverlay button:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(122, 163, 209, 0.4);
      }

      #memorialPopupOverlay .close-btn:hover {
        background: rgba(255, 255, 255, 0.3) !important;
        transform: scale(1.1);
      }

      @media (max-width: 600px) {
        #memorialPopupOverlay > div {
          width: 95% !important;
          margin: 10px !important;
        }
        
        #memorialPopupOverlay h2 {
          font-size: 26px !important;
        }
        
        #memorialPopupOverlay .content {
          padding: 25px 20px !important;
        }
        
        #memorialPopupOverlay .bg-header {
          height: 160px !important;
        }
      }

      @media (max-width: 480px) {
        #memorialPopupOverlay h2 {
          font-size: 22px !important;
        }
        
        #memorialPopupOverlay p {
          font-size: 16px !important;
        }
      }
      </style>
    `;
    
    document.body.insertAdjacentHTML('beforeend', popupHTML);
  }

  function showMemorialPopup() {
    const overlay = document.getElementById('memorialPopupOverlay');
    if (overlay) {
      overlay.style.display = 'block';
    }
  }

  window.closeMemorialPopup = function() {
    const overlay = document.getElementById('memorialPopupOverlay');
    if (overlay) {
      overlay.style.opacity = '0';
      setTimeout(() => {
        overlay.style.display = 'none';
        overlay.style.opacity = '1';
      }, 300);
    }
  };

  function setupEventListeners() {
    document.addEventListener('click', function(e) {
      const overlay = document.getElementById('memorialPopupOverlay');
      if (e.target === overlay) closeMemorialPopup();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeMemorialPopup();
    });
  }

  function initMemorialPopup() {
    if (shouldShowPopup()) {
      createPopupHTML();
      setupEventListeners();
      setTimeout(showMemorialPopup, POPUP_CONFIG.showDelay);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMemorialPopup);
  } else {
    initMemorialPopup();
  }

})();